export const sortAlphaNum = (a, b) => {
  if (a && b) {
    const reA = /[^a-zA-Z]/g
    const reN = /[^0-9]/g
    const aA = a.replace(reA, '')
    const bA = b.replace(reA, '')
    if (aA === bA) {
      const aN = parseInt(a.replace(reN, ''), 10)
      const bN = parseInt(b.replace(reN, ''), 10)
      return aN === bN ? 0 : aN > bN ? 1 : -1
    } else {
      return aA > bA ? 1 : -1
    }
  } else if (a === null) {
    return 1
  } else if (b === null) {
    return -1
  }
}

export const removeFileExtension = (fileName = '') => {
  return (fileName || '')?.replace(/\.[^/.]+$/, '')
}

export const extractFileType = (fileName = '') => {
  const match = (fileName || '')?.match(/\.(\w+)$/)
  return match ? match[1]?.toLowerCase() : ''
}

export const parseDateOnly = (value) => {
  if (!value) return null
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const s = String(value).trim()
  const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})/.exec(s)
  if (m) {
    const year = Number(m[1])
    const month = Number(m[2])
    const day = Number(m[3])
    const d = new Date(year, month - 1, day)
    if (!Number.isNaN(d.getTime())) return d
  }

  const d = new Date(s)
  if (Number.isNaN(d.getTime())) return null
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}
